'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardActionsStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

var _CardAreaSideStyled = require('../../CardAreaSide/styles/CardAreaSideStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
  theme: _propTypes2.default.object
};
var defaultProps = {
  size: 'default'
};

var sizeProps = function sizeProps(_ref) {
  var themeFromProvider = _ref.theme,
      size = _ref.size;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.card.actions.size[size];
  var _source$mainRegion = source.mainRegion,
      mainPaddingY = _source$mainRegion.paddingY,
      mainPaddingX = _source$mainRegion.paddingX;
  var _source$sideRegion = source.sideRegion,
      sidePaddingY = _source$sideRegion.paddingY,
      sidePaddingX = _source$sideRegion.paddingX;
  return (0, _styledComponents.css)(['padding:', ' ', ';', ' &{padding:', ' ', ';flex-direction:column;}'], (0, _reactackleCore.getValueString)(mainPaddingY), (0, _reactackleCore.getValueString)(mainPaddingX), _CardAreaSideStyled.CardAreaSideStyled, (0, _reactackleCore.getValueString)(sidePaddingY), (0, _reactackleCore.getValueString)(sidePaddingX));
};

var CardActionsStyled = exports.CardActionsStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardActionsStyled'
})(['display:flex;position:relative;', ';'], sizeProps);

CardActionsStyled.propTypes = propTypes;
CardActionsStyled.defaultProps = defaultProps;
CardActionsStyled.displayName = 'CardActionsStyled';